import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=2ec02a2d"
import script from "./image-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-item.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./image-item.vue?vue&type=style&index=0&id=2ec02a2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports